<template>
  <div id="sumamry-container">
    <v-simple-table>
      <template v-slot:default>
        <tbody>
          <tr v-for="item in details" :key="item.name">
            <td>
              <b>{{ item.name }}</b>
            </td>
            <td>{{ item.value }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
export default {
  props: {
    item: Object, // centre object passed from CentreDetails component
  },
  mounted: function () {
    this.section = this.$route.params.section;
    this.id = this.$route.query.id || this.$route.query.centreId;

    this.getCentre();
  },
  data() {
    return {
      details: [],
      mapper: [
        {
          name: "Centre Code",
          mapTo: "code",
        },
        {
          name: "Centre Name",
          mapTo: "name",
        },
        {
          name: "Centre City",
          mapTo: "city",
        },
        {
          name: "First Approved Date",
          mapTo: "firstApprovedDate",
        },
        {
          name: "RenewalDate",
          mapTo: "renewalDate",
        },
        {
          name: "UKPRN / Trainer Number",
          mapTo: "ukprn",
        },
        {
          name: "Status",
          mapTo: "status",
        },
        {
          name: "Address Line 1",
          mapTo: "addressLine1",
        },
        {
          name: "Address Line 2",
          mapTo: "addressLine2",
        },
        {
          name: "Address Line 3",
          mapTo: "addressLine3",
        },
        {
          name: "Post Code",
          mapTo: "postcode",
        },
        {
          name: "Country",
          mapTo: "country",
        },
        {
          name: "Main Contact First Name",
          mapTo: "mainContactFirstName",
        },
        {
          name: "Main Contact Middle Name",
          mapTo: "mainContactMiddleName",
        },
        {
          name: "Main Contact Last Name",
          mapTo: "mainContactLastName",
        },
        {
          name: "Main Contact Email",
          mapTo: "mainContactEmail",
        },
        {
          name: "Main Contact Telephone",
          mapTo: "mainContactTelephone",
        },
        {
          name: "Main Contact Mobile",
          mapTo: "mainContactMobile",
        },
        {
          name: "Admin Contact First Name",
          mapTo: "adminContactFirstName",
        },
        {
          name: "Admin Contact Middle Name",
          mapTo: "adminContactMiddleName",
        },
        {
          name: "Admin Contact Last Name",
          mapTo: "adminContactLastName",
        },
        {
          name: "Admin Contact Email",
          mapTo: "adminContactEmail",
        },
        {
          name: "Admin Contact Telephone",
          mapTo: "adminContactTelephone",
        },
        {
          name: "Admin Contact Mobile",
          mapTo: "adminContactMobile",
        },
        {
          name: "Account Contact First Name",
          mapTo: "accountContactFirstName",
        },
        {
          name: "Account Contact Middle Name",
          mapTo: "accountContactMiddleName",
        },
        {
          name: "Account Contact Last Name",
          mapTo: "accountContactLastName",
        },
        {
          name: "Account Contact Email",
          mapTo: "accountContactEmail",
        },
        {
          name: "Account Contact Telephone",
          mapTo: "accountContactTelephone",
        },
        {
          name: "Account Contact Mobile",
          mapTo: "accountContactMobile",
        },
      ],
    };
  },
  methods: {
    getCentre: function () {
      // execute for new centre summary
      if (this.item) {
        this.writeToTable(this.item);
        return;
      }

      // execute for existing centre summary
      fetch(`${process.env.VUE_APP_ROOT_API}/centres/${this.id}`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          this.writeToTable(data.centre);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    writeToTable: function (item) {
      // to arrange the details to summary table in the desirable order
      this.mapper.map((key) => {
        Object.keys(item).map((i) => {
          if (key.mapTo == i) {
            this.details.push({ name: key.name, value: item[i] });
          }
        });
      });
    },
  },
};
</script>

<style scoped>
#sumamry-container {
  min-height: 100vh;
}
</style>